import { Children, cloneElement, isValidElement } from 'react';
import cn from 'classnames';
import { Typography, Spinner } from 'seagull';
import styles from "./GraphWidgetLayout.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Renders the basic layout for a graph widget - a variable amount of cards in the 1st row,
 * and a full-width card in the 2nd row.
 */
export default function GraphWidgetLayout(props) {
  const {
    children,
    title,
    subtitle,
    loading,
    bottomHeight = 'm',
    testid
  } = props;
  const childrenLength = Children.count(children);
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": testid,
    children: [title && /*#__PURE__*/_jsxs(Typography, {
      weight: "normal",
      skin: "secondary",
      variant: "h6",
      className: styles.title,
      children: [title, loading && /*#__PURE__*/_jsx(Spinner, {
        "data-testid": "graph-widget-loading",
        size: 24
      })]
    }), subtitle && /*#__PURE__*/_jsx("div", {
      className: styles.title,
      children: subtitle
    }), /*#__PURE__*/_jsx("div", {
      className: cn(styles.grid, styles["".concat(bottomHeight, "BottomHeight")]),
      style: {
        '--num-cols': childrenLength - 1
      },
      children: Children.map(children, (child, idx) => {
        const isLastChild = idx === childrenLength - 1;
        if (isLastChild && /*#__PURE__*/isValidElement(child)) {
          return /*#__PURE__*/cloneElement(child, {
            className: cn(child.props.className, styles.fullWidthCell)
          });
        }
        return child;
      })
    })]
  });
}